exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div.email-select .ant-form-item {\n  display: inline-block; }\n\ndiv.email-select div.email-select-hover-helper {\n  display: inline-block; }\n\ndiv.email-select .email-select-label {\n  padding-bottom: 7px; }\n  div.email-select .email-select-label label {\n    font-size: 12;\n    color: rgba(0, 0, 0, 0.65); }\n  div.email-select .email-select-label .required:before {\n    display: inline-block;\n    margin-right: 4px;\n    content: \"*\";\n    font-family: SimSun;\n    line-height: 1;\n    font-size: 12px;\n    color: #f04134; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/common/components/EmailSelect/style.scss
// module id = 1021
// module chunks = 0